import * as THREE from '../../dist/three.module.js';
import mapboxgl from 'mapbox-gl';
import * as TWEEN from '@tweenjs/tween.js';
import * as turf from '@turf/turf';
import { latLngToCell } from "h3-js";

import {
  fmesh,
  fullmesh,
  fmeshPoints,
  foundFeature,
  setFoundFeature,
  animate_speed,
  mapPalette
} from './globalVariables.js';

let setIsLoading;
let setIsVisible;
let setClickedInfo;
let setClickedInfoHeader;
let longstandingGeoJSONRef;
let selectedYearEditing;
let setdropdownhighlightedIndex;
let is2DViewActive;
let setIs2DViewActive;
let isCtrlDown;
let selectedMetric;
let newFeatureDepth;
let setAcknowledgeNewFaetureNewDepth;
let setUniversalDataLoaded;
let landKeySelectedKey;
let globalPolygonTransparency;
let activeLayer;
let layers;
let hiddenLayer;
let multiLayerSelected;
let multuLayerSelectedArray;
let setMultuLayerSelectedArray
let multuGroupSelectedArray;
let setMultuGroupSelectedArray;
let SMSelectedArray;
let setSMSelectedArray;
let dynamicMultuGroupSelectedArray;
let h3;
let isWorkingWithinRealm;
let isRealmLeftClickedInfoVisible
let setIsRealmLeftClickedInfoVisible
let isRighdivrawerVisible;
let setIsRighdivrawerVisible;
let activeTab;
let setActiveTab;
let currentMapIdRef;
let relativitySliderAmount;
let debugMode;
let setClickedInfoTab;
let numericTimeAggregationMethod;
let setLoadedPercentage;

// 

let LOADINGPARAM_makeScene;
let setLOADINGPARAM_makeScene;

let LOADINGPARAM_initAnimation;
let setLOADINGPARAM_initAnimation;

let LOADINGPARAM_onAdd;
let setLOADINGPARAM_onAdd;

let LOADINGPARAM_createShapes;
let setLOADINGPARAM_createShapes;

class harrierPolygonLayer {

  type = 'custom';
  renderingMode = '3d';

  // constructor - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

  constructor(
    id,
    latitude,
    longitude,
    json,
    globalRefs,
    globalState,
    colorPaletteName,
    parcelDifferentiator
  ) {
    this.id = id;
    this.center = { latitude, longitude };
    this.passedjson = json;
    this.modelTransform = this.calculateModelTransform();
    this.map = globalRefs.mapRef;
    this.colorPaletteName = colorPaletteName;
    this.parcelDifferentiator = parcelDifferentiator;
    this.featureById = new Map(
      (json?.features || []).map((feature) => [String(feature.skylark_id), feature])
    );
    this.globalValuesMatrix = {};
    this.currentlandKeySelectedKey = landKeySelectedKey;
    this.resolution = 4;
    this.individuallySelectedParcelBool = false;
    this.multuGroupSelectedArray = [];
    this.pointGeometryRadius = 5;
    this.polygonLayerLeftSubDrawerOpen = false;
    this.scenarioFeatureSelectionMode = false;
    this.polygonSingleFeatureEditMode = false;
    setIsLoading = globalState.setIsLoading;
    setIsVisible = globalState.setIsVisible;
    setClickedInfo = globalState.setClickedInfo;
    setClickedInfoHeader = globalState.setClickedInfoHeader;
    longstandingGeoJSONRef = globalRefs.longstandingGeoJSONRef;
    selectedMetric = globalState.selectedMetric;
    selectedYearEditing = globalState.selectedYearEditing;
    this.scenarioModels = globalState.scenarioModels || [];
    this.scenarioModelledViewEnabled = Boolean(globalState.scenarioModelledViewEnabled);
    this.numericTimeAggregationMethod = globalState.numericTimeAggregationMethod;
    setdropdownhighlightedIndex = globalState.setdropdownhighlightedIndex;
    is2DViewActive = globalState.is2DViewActive;
    setIs2DViewActive = globalState.setIs2DViewActive;
    landKeySelectedKey = globalState.landKeySelectedKey;
    globalPolygonTransparency = globalState.globalPolygonTransparency;
    isCtrlDown = false;
    setAcknowledgeNewFaetureNewDepth = globalState.setAcknowledgeNewFaetureNewDepth;
    setUniversalDataLoaded = globalState.setUniversalDataLoaded;
    activeLayer = globalState.activeLayer;
    layers = globalState.layers;
    hiddenLayer = globalState.hiddenLayer;
    multiLayerSelected = globalState.multiLayerSelected;
    multuLayerSelectedArray = globalState.multuLayerSelectedArray;
    setMultuLayerSelectedArray = globalState.setMultuLayerSelectedArray;
    multuGroupSelectedArray = globalState.multuGroupSelectedArray;
    setMultuGroupSelectedArray = globalState.setMultuGroupSelectedArray;
    SMSelectedArray = globalState.SMSelectedArray;
    setSMSelectedArray = globalState.setSMSelectedArray;
    this.scenarioModelledFeatureIds = [];
    dynamicMultuGroupSelectedArray = [];
    isRighdivrawerVisible = globalState.isRighdivrawerVisible;
    setIsRighdivrawerVisible = globalState.setIsRighdivrawerVisible;
    activeTab = globalState.activeTab;
    setActiveTab = globalState.setActiveTab;
    isWorkingWithinRealm = globalState.isWorkingWithinRealm;
    isRealmLeftClickedInfoVisible = globalState.isRealmLeftClickedInfoVisible;
    setIsRealmLeftClickedInfoVisible = globalState.setIsRealmLeftClickedInfoVisible;
    currentMapIdRef = globalRefs.currentMapIdRef;
    h3 = require("h3-js");
    relativitySliderAmount = globalState.relativitySliderAmount;
    debugMode = globalState.debugMode;
    setClickedInfoTab = globalState.setClickedInfoTab;
    numericTimeAggregationMethod = globalState.numericTimeAggregationMethod;
    setLoadedPercentage = globalState.setLoadedPercentage;
    // 
    LOADINGPARAM_makeScene = globalState.LOADINGPARAM_makeScene;
    setLOADINGPARAM_makeScene = globalState.setLOADINGPARAM_makeScene;
    LOADINGPARAM_initAnimation = globalState.LOADINGPARAM_initAnimation;
    setLOADINGPARAM_initAnimation = globalState.setLOADINGPARAM_initAnimation;
    LOADINGPARAM_onAdd = globalState.LOADINGPARAM_onAdd;
    setLOADINGPARAM_onAdd = globalState.setLOADINGPARAM_onAdd;
    LOADINGPARAM_createShapes = globalState.LOADINGPARAM_createShapes;
    setLOADINGPARAM_createShapes = globalState.setLOADINGPARAM_createShapes;
  }

  // initial setup functions - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

  async onAdd(map, gl) {
    this.scene = this.makeScene();
    this.checkDifferential(this.passedjson, selectedYearEditing);
    this.renderer = new THREE.WebGLRenderer({
      canvas: map.getCanvas(),
      context: gl,
      antialias: false,
      logarithmicDepthBuffer: false,
      preserveDrawingBuffer: false,
    });
    if (debugMode) {
      const timestamp = new Date().toISOString();
      console.group(timestamp + " " + "🖥️ WEBGL DEBUG INITIALISATION");
      console.log("🎮 WebGL Context", gl);
      const debugInfo = gl.getExtension("WEBGL_debug_renderer_info");
      if (debugInfo) {
        console.log(
          "🖥️ GPU Vendor:",
          gl.getParameter(debugInfo.UNMASKED_VENDOR_WEBGL)
        );
        console.log(
          "🎨 GPU Renderer:",
          gl.getParameter(debugInfo.UNMASKED_RENDERER_WEBGL)
        );
      }
      console.log(
        "📐 Max Texture Size:",
        gl.getParameter(gl.MAX_TEXTURE_SIZE)
      );
      console.log(
        "🧱 Max Vertex Attributes:",
        gl.getParameter(gl.MAX_VERTEX_ATTRIBS)
      );
      console.groupEnd();
    }
    this.renderer.autoClear = false;
    this.map = map;
    this.raycaster = new THREE.Raycaster();
    this.raycaster.near = -1;
    this.raycaster.far = 1e10;
    setUniversalDataLoaded(false);
    // 
    setLOADINGPARAM_onAdd(true)
  }

  // scene creation relation functions - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

  makeScene() {
    const timestamp = new Date().toISOString();
    if (debugMode) console.group(timestamp + " " + "🎬 THREE SCENE CREATION OBJECTS & PARAMS");
    const scene = new THREE.Scene();
    if (debugMode) console.log("🌍 Scene created", scene);
    this.camera = new THREE.PerspectiveCamera();
    this.camera.far = 1000000000;
    if (debugMode) console.log("📷 PerspectiveCamera created", this.camera);
    const skyColor = 0xb1e1ff;
    const groundColor = 0xb97a20;
    this.templight = new THREE.AmbientLight(0xffffff, 0.6);
    if (debugMode) console.log("💡 Template AmbientLight created", this.templight);
    const ambientLight = new THREE.AmbientLight(0xffffff, 0.6);
    scene.add(ambientLight);
    if (debugMode) console.log("✨ AmbientLight added to scene", ambientLight);
    const hemisphereLight = new THREE.HemisphereLight(skyColor, groundColor, 0.25);
    scene.add(hemisphereLight);
    if (debugMode) console.log("🌤️ HemisphereLight added to scene", hemisphereLight);
    let fullMeshPosition = new THREE.Vector3();
    if (debugMode) console.log("📍 Vector3 created", fullMeshPosition);
    fullmesh.getWorldPosition(fullMeshPosition);
    if (debugMode) console.log("🗺️ Full mesh world position", fullMeshPosition);
    this.directionalLight = new THREE.DirectionalLight(0xffffff, 0.08);
    this.directionalLight.position.set(fullMeshPosition.x, fullMeshPosition.z, fullMeshPosition.y + 1000).normalize();
    scene.add(this.directionalLight);
    if (debugMode) console.log("☀️ DirectionalLight #1 added", this.directionalLight);
    this.directionalLight2 = new THREE.DirectionalLight(0xffffff, 0.08);
    this.directionalLight2.rotateX = Math.PI / 2;
    this.directionalLight2.position.set(fullMeshPosition.x, fullMeshPosition.z, fullMeshPosition.y - 1000).normalize();
    scene.add(this.directionalLight2);
    if (debugMode) console.log("🌙 DirectionalLight #2 added", this.directionalLight2);
    this.directionalLight3 = new THREE.DirectionalLight(0xffffff, 0.1);
    this.directionalLight3.rotateX = Math.PI / 2;
    this.directionalLight3.position.set(fullMeshPosition.x, fullMeshPosition.z + 250, fullMeshPosition.y).normalize();
    scene.add(this.directionalLight3);
    if (debugMode) {
      console.log("🔦 DirectionalLight #3 added", this.directionalLight3);
      console.log("🎬 Final scene", scene);
      console.log("📦 Scene children count:", scene.children.length);
      console.groupEnd();
    }
    // 
    setLOADINGPARAM_makeScene(true)
    return scene;
  }

  // polygon map relation functions - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

  calculateModelTransform() {
    const modelOrigin = [this.center.longitude, this.center.latitude];
    const modelAltitude = 2;
    const modelRotate = [Math.PI / 2, 0, 0];
    const modelAsMercatorCoordinate = mapboxgl.MercatorCoordinate.fromLngLat(
      modelOrigin,
      modelAltitude
    );
    return {
      translateX: modelAsMercatorCoordinate.x,
      translateY: modelAsMercatorCoordinate.y,
      translateZ: modelAsMercatorCoordinate.z,
      rotateX: modelRotate[0],
      rotateY: modelRotate[1],
      rotateZ: modelRotate[2],
      scale: modelAsMercatorCoordinate.meterInMercatorCoordinateUnits(),
    };
  }

  // polygon generation start proceedure - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

  checkDifferential = (geojson, selectedYearEditing) => {
    longstandingGeoJSONRef.current = geojson;
    this.createShapes(longstandingGeoJSONRef.current, selectedYearEditing);
  }

  // polygon render functions - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

  filterGeojsonFeatures(geojson, selectedYearEditing) {
    return geojson.features.filter(feature => {
      let deletedDataCut = feature.feature_data_standard.deleted
        ? feature.feature_data_standard.deleted.slice(0, 4)
        : null;
      let selectedYearEditingCut = selectedYearEditing
        ? selectedYearEditing.slice(0, 4)
        : null;
      let createdDataCut = feature.feature_data_standard.created
        ? feature.feature_data_standard.created.slice(0, 4)
        : null;
      if (deletedDataCut <= selectedYearEditingCut && deletedDataCut !== null) {
        return false;
      }
      if (createdDataCut > selectedYearEditingCut) {
        return false;
      }
      return true;
    });
  }

  setPointGeometryScaleBasedOnZoom = (zoomRatio) => {
    this.pointGeometryRadius = zoomRatio;
  }

  createShapeFromFeature(feature, selectedYearEditing, modelTransform) {
    const clampLngLat = (coords) => {
      const lng = Math.max(-180, Math.min(180, coords[0]));
      const lat = Math.max(-90, Math.min(90, coords[1]));
      return { lng, lat };
    };
    const createShapeFromCoordinates = (coordinates) => {
      const shapeCoords = coordinates.map(coords => {
        if (isNaN(coords[0]) || isNaN(coords[1])) {
          return new THREE.Vector2(0, 0);
        }
        const { lng, lat } = clampLngLat(coords);
        const mercatorCoord = mapboxgl.MercatorCoordinate.fromLngLat({ lng, lat });

        if (isNaN(mercatorCoord.x) || isNaN(mercatorCoord.y)) {
          console.error('Invalid Mercator coordinate:', mercatorCoord);
          return new THREE.Vector2(0, 0);
        }
        return new THREE.Vector2(
          (mercatorCoord.x - modelTransform.translateX) / modelTransform.scale,
          (mercatorCoord.y - modelTransform.translateY) / modelTransform.scale
        );
      });
      if (!shapeCoords[0].equals(shapeCoords[shapeCoords.length - 1])) {
        shapeCoords.push(shapeCoords[0]);
      }
      return new THREE.Shape(shapeCoords);
    };

    const createShapeFromPoint = (coord) => {
      const radius = this.pointGeometryRadius; // Adjust for desired size in Three.js units
      const segments = 36;
      const { lng, lat } = clampLngLat(coord);
      const mercatorCoord = mapboxgl.MercatorCoordinate.fromLngLat({ lng, lat });
      const center = new THREE.Vector2(
        (mercatorCoord.x - modelTransform.translateX) / modelTransform.scale,
        (mercatorCoord.y - modelTransform.translateY) / modelTransform.scale
      );
      const points = [];
      for (let i = 0; i < segments; i++) {
        const angle = (i / segments) * Math.PI * 2;
        points.push(new THREE.Vector2(
          center.x + Math.cos(angle) * radius,
          center.y + Math.sin(angle) * radius
        ));
      }
      points.push(points[0]); // close the circle
      return new THREE.Shape(points);
    };

    // Determine coordinates
    let passedcoordinates;
    const boundaryChange = feature.feature_data_simple_timeseries?.BoundaryChange;
    if (!boundaryChange || boundaryChange[selectedYearEditing] === undefined || boundaryChange[selectedYearEditing] === "000,000") {
      passedcoordinates = feature.geometry.coordinates;
    } else {
      passedcoordinates = JSON.parse(boundaryChange[selectedYearEditing]);
    }

    // Handle geometry types
    if (feature.geometry.type === 'MultiPolygon') {
      const shapes = [];
      passedcoordinates.forEach(polygonCoords => {
        polygonCoords.forEach(ring => {
          shapes.push(createShapeFromCoordinates(ring));
        });
      });
      return shapes;
    } else if (feature.geometry.type === 'Polygon') {
      if (
        Array.isArray(passedcoordinates) &&
        Array.isArray(passedcoordinates[0]) &&
        typeof passedcoordinates[0][0] !== 'undefined'
      ) {
        return createShapeFromCoordinates(passedcoordinates[0]);
      } else {
        console.warn('Invalid or missing coordinates, skipping shape creation.');
        return null;
      }
    } else if (feature.geometry.type === 'Point') {
      if (Array.isArray(passedcoordinates) && passedcoordinates.length === 2) {
        return createShapeFromPoint(passedcoordinates);
      } else {
        console.warn('Invalid point coordinates:', passedcoordinates);
        return null;
      }
    } else {
      console.error('Unsupported geometry type:', feature.geometry.type);
      return null;
    }
  }

  createMeshForFeature(geojson, feature, selectedMetric, selectedYearEditing, modelTransform) {
    let internalDepth;
    if (is2DViewActive === true) {
      internalDepth = 0;
    } else {
      internalDepth = 1;
    }
    const geometryType = feature.geometry?.type;
    const toMapPoint = (coord) => {
      const mercator = mapboxgl.MercatorCoordinate.fromLngLat({ lng: coord[0], lat: coord[1] });
      return new THREE.Vector3((mercator.x - modelTransform.translateX) / modelTransform.scale, (mercator.y - modelTransform.translateY) / modelTransform.scale, 0);
    };
    let mesh;
    if (geometryType === 'LineString' || geometryType === 'MultiLineString') {
      mesh = new THREE.Group();
      const paths = geometryType === 'LineString' ? [feature.geometry.coordinates] : feature.geometry.coordinates;
      paths.forEach((path) => {
        if (!Array.isArray(path) || path.length < 2) return;
        const points = path.map(toMapPoint);
        const zoom = this.map?.getZoom?.() ?? 5;
        const latitudeScale = Math.cos(this.center.latitude * Math.PI / 180);
        const metersPerPixel = latitudeScale * 40075017 / (Math.pow(2, zoom) * 512);
        const halfWidth = Math.max(metersPerPixel * .005, 0.05);
        const positions = [];
        const indices = [];
        const addVertex = (x, y, z = 0) => {
          positions.push(x, y, z);
          return positions.length / 3 - 1;
        };

        for (let i = 0; i < points.length - 1; i += 1) {
          const start = points[i];
          const end = points[i + 1];
          const dx = end.x - start.x;
          const dy = end.y - start.y;
          const length = Math.hypot(dx, dy);
          if (!length) continue;
          const offsetX = -dy / length * halfWidth;
          const offsetY = dx / length * halfWidth;
          const startLeft = addVertex(start.x + offsetX, start.y + offsetY);
          const startRight = addVertex(start.x - offsetX, start.y - offsetY);
          const endLeft = addVertex(end.x + offsetX, end.y + offsetY);
          const endRight = addVertex(end.x - offsetX, end.y - offsetY);
          indices.push(startLeft, startRight, endLeft, startRight, endRight, endLeft);
        }

        // Round joins and endpoints keep adjacent segment strips connected.
        points.forEach((point) => {
          const centerIndex = addVertex(point.x, point.y);
          const ring = [];
          for (let i = 0; i < 8; i += 1) {
            const angle = (i / 8) * Math.PI * 2;
            ring.push(addVertex(
              point.x + Math.cos(angle) * halfWidth,
              point.y + Math.sin(angle) * halfWidth
            ));
          }
          for (let i = 0; i < ring.length; i += 1) {
            indices.push(centerIndex, ring[i], ring[(i + 1) % ring.length]);
          }
        });

        const geometry = new THREE.BufferGeometry();
        geometry.addAttribute('position', new THREE.Float32BufferAttribute(positions, 3));
        geometry.setIndex(indices);
        mesh.add(new THREE.Mesh(
          geometry,
          new THREE.MeshBasicMaterial({ color: 0x29645D, side: THREE.DoubleSide })
        ));
      });
    } else {
      const shape = this.createShapeFromFeature(feature, selectedYearEditing, modelTransform);
      const shapes = Array.isArray(shape) ? shape : [shape];
      const parts = shapes.filter(Boolean).map((part) => new THREE.Mesh(
        new THREE.ExtrudeGeometry(part, { depth: internalDepth, bevelEnabled: false }),
        new THREE.MeshPhongMaterial({ color: 0xffffff })
      ));
      mesh = parts.length === 1 ? parts[0] : new THREE.Group();
      if (parts.length > 1) parts.forEach((part) => mesh.add(part));
    }
    const selectedMetricValue = this.getFeatureValue(feature, selectedMetric, selectedYearEditing);
    const uniqueDifferentiators = new Set();
    // Check if parcelDifferentiator is null or empty
    const isParcelDifferentiatorEmpty = !this.parcelDifferentiator || this.parcelDifferentiator === '';
    if (!isParcelDifferentiatorEmpty) {
      // Populate the set of unique differentiators
      geojson.features
        .map(feature => feature.feature_data_simple_timeseries[this.parcelDifferentiator]?.[selectedYearEditing])
        .filter(value => value !== undefined)
        .forEach(value => uniqueDifferentiators.add(value));
    }
    mesh.renderOrder = Math.random() * 10;
    mesh.name = feature.skylark_id;
    mesh.traverse((object) => {
      if (object !== mesh) object.name = feature.skylark_id;
    });
    if (geometryType === 'Point') {
      mesh.point = true;
    }
    mesh.scale.z = -selectedMetricValue * 1 || 0.01;
    return mesh;
  }

  getFeatureValue(feature, key, selectedTimestamp) {
    if (this.scenarioModelledViewEnabled) {
      const scenarioChange = this.getScenarioChangeForFeature(feature, selectedTimestamp);
      if (scenarioChange) {
        if (key === 'HabitatType') return scenarioChange.newLandtype ?? this.getAggregatedValue(feature.feature_data_simple_timeseries, key, selectedTimestamp);
        if (key === 'ParcelCarbon' && Number.isFinite(scenarioChange.newParcelCarbon)) return scenarioChange.newParcelCarbon;
        if (key === 'BD_Parcel' && Number.isFinite(scenarioChange.newBiodiversity)) return scenarioChange.newBiodiversity;
      }
    }
    return this.getAggregatedValue(feature.feature_data_simple_timeseries, key, selectedTimestamp);
  }

  getScenarioChangeForFeature(feature, selectedTimestamp) {
    const selectedDate = new Date(selectedTimestamp);
    if (Number.isNaN(selectedDate.getTime())) return null;
    // Later-created actions take precedence over earlier ones for every period
    // from their effective year onward, even when they target an earlier year.
    const applicableScenarios = this.scenarioModels
      .filter((scenario) => {
        if (scenario.aggregationMethod !== this.numericTimeAggregationMethod) return false;
        const actionDate = new Date(scenario.selectedYear);
        if (Number.isNaN(actionDate.getTime())) return false;
        // Scenario actions persist through later periods at their selected aggregation level.
        switch (scenario.aggregationMethod) {
          case 'year': return actionDate.getUTCFullYear() <= selectedDate.getUTCFullYear();
          case 'month': return actionDate.getUTCFullYear() < selectedDate.getUTCFullYear() || (actionDate.getUTCFullYear() === selectedDate.getUTCFullYear() && actionDate.getUTCMonth() <= selectedDate.getUTCMonth());
          case 'day': return actionDate <= selectedDate;
          case 'hour': return actionDate <= selectedDate;
          default: return scenario.selectedYear <= selectedTimestamp;
        }
      });
    for (const scenario of applicableScenarios.reverse()) {
      const change = (scenario.features || []).find((item) => String(item.featureId) === String(feature.skylark_id));
      if (change) return change;
    }
    return null;
  }

  stringToHexColor = (str) => {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    return mapPalette[Math.abs(hash) % mapPalette.length];
  };

  getRandomPolygonColor(landKeySelectedKey) {
    const colorMap = {};
    const keyCategories = [];
    fmesh.children.forEach((child) => {
      const skylarkId = child.name;
      const feature = longstandingGeoJSONRef.current.features.find(
        (f) => f.skylark_id === skylarkId
      );
      if (feature) {
        const keyCategory = this.getFeatureValue(feature, landKeySelectedKey, selectedYearEditing);
        if (keyCategory !== undefined && !keyCategories.includes(keyCategory)) {
          keyCategories.push(keyCategory); // Add unique categories to the array
        }
      }
    });
    keyCategories.sort();
    keyCategories.forEach((keyCategory, index) => {
      const color = new THREE.Color(this.stringToHexColor(keyCategory));
      colorMap[keyCategory] = color;
    });
    fmesh.children.forEach((child) => {
      const skylarkId = child.name;
      const feature = longstandingGeoJSONRef.current.features.find(
        (f) => f.skylark_id === skylarkId
      );
      if (!feature) return;
      const keyCategory =
        this.getFeatureValue(feature, landKeySelectedKey, selectedYearEditing);
      const color = keyCategory !== undefined && colorMap[keyCategory] ? colorMap[keyCategory] : new THREE.Color(0x29645D);
      child.traverse((object) => {
        if (object.material?.color) object.material.color.copy(color);
        if (object.material) object.material.needsUpdate = true;
      });
    });
    fmeshPoints.children.forEach(child => {
      if (Array.isArray(child.material)) {
        child.material.forEach(mat => mat.color.set(0x29645D));
      } else if (child.material?.color) {
        child.material.color.set(0x29645D);
      }
    });
    fmesh.traverse((child) => {
      if (child.isMesh) {
        child.material.opacity = 1;
        child.material.transparent = true;
        child.material.needsUpdate = true;
      }
    });
    this.map_repaint();
  }

  createShapes(geojson, selectedYearEditing) {
    this.clearMeshGroup(fmesh);
    this.clearMeshGroup(fmeshPoints);
    const timestamp = new Date().toISOString();
    if (debugMode) {
      console.group(timestamp + " " + "🚀 CREATE SHAPES FUNCTION DETAILS()");
      console.log("📥 Incoming GeoJSON Features:", geojson.features.length);
      console.log("📅 Selected Year:", selectedYearEditing);
      console.log("📊 Selected Metric:", selectedMetric);
    }
    let filteredGeojson = {
      type: "FeatureCollection",
      features: this.filterGeojsonFeatures(geojson, selectedYearEditing)
    };
    if (debugMode) {
      console.log("🗂️ Filtered Features:", filteredGeojson.features.length);
    }
    this.modelTransform = this.calculateModelTransform();
    if (debugMode) {
      console.log("🌍 Model Transform:", this.modelTransform);
    }
    fmesh.position.set(0, 0, 0);
    fmeshPoints.position.set(0, 0, 2);
    const bbox = turf.bbox(filteredGeojson);
    if (debugMode) {
      console.log("📐 Bounding Box:", bbox);
    }
    const geoWidth = bbox[2] - bbox[0];
    const geoHeight = bbox[3] - bbox[1];
    if (debugMode) {
      console.log("↔️ Geo Width:", geoWidth);
      console.log("↕️ Geo Height:", geoHeight);
    }
    const maxHeightPercentage = 20000;
    const maxHeight =
      Math.min(geoWidth, geoHeight) *
      maxHeightPercentage *
      relativitySliderAmount;
    if (debugMode) {
      console.log("📏 Max Height:", maxHeight);
    }
    const metricValues = filteredGeojson.features.map(feature =>
      this.getFeatureValue(feature, selectedMetric, selectedYearEditing)
    );
    // console.log(metricValues)
    const maxMetricValue = Math.max(...metricValues);
    const minMetricValue = Math.min(...metricValues);
    if (debugMode) {
      console.log("📈 Max Metric Value:", maxMetricValue);
      console.log("📉 Min Metric Value:", minMetricValue);
    }
    let meshesCreated = 0;
    const debugMeshes = [];
    filteredGeojson.features.forEach(feature => {
      const metricValue = this.getFeatureValue(feature, selectedMetric, selectedYearEditing);
      let height;
      if (metricValue >= 0) {
        height = this.calculateHeight(
          metricValue,
          maxMetricValue,
          maxHeight
        );
      } else {
        height = this.calculateHeight(
          Math.abs(metricValue),
          Math.abs(minMetricValue),
          maxHeight
        );
      }
      if (height === 0) height = 1;
      const mesh = this.createMeshForFeature(
        geojson,
        feature,
        selectedMetric,
        selectedYearEditing,
        this.modelTransform,
        is2DViewActive
      );
      meshesCreated++;
      if (debugMode) {
        debugMeshes.push({
          index: meshesCreated - 1,
          skylark_id: feature.skylark_id,
          geometryType: feature.geometry?.type,
          metricValue,
          height,
          mesh
        });
      }
      // DELETE AND SORT OUT THE BELOW BULLSHIT FOR A SPECIFIC DEMO 04/06/26
      if (currentMapIdRef.current === '578768ef-809e-47db-9068-72c001478ab7') {
        mesh.scale.set(
          1,
          1,
          metricValue >= 0 ? -height * 0.01 : height * 0.01
        );
      } else {
        mesh.scale.set(
          1,
          1,
          metricValue >= 0 ? -height : height
        );
      }
      // END OF DELETE AND SORT OUT THE BELOW BULLSHIT FOR A SPECIFIC DEMO 04/06/26
      const geomType = feature.geometry?.type;
      if (geomType === "Point" || geomType === "MultiPoint") {
        fmeshPoints.add(mesh);
      } else {
        fmesh.add(mesh);
      }
    });
    const box = new THREE.Box3().setFromObject(fmesh);
    const modelCenter = box.getCenter(new THREE.Vector3());
    if (debugMode) {
      console.log("📦 Model Bounding Box:", box);
      console.log("🎯 Model Center:", modelCenter);
    }
    fullmesh.add(fmesh);
    if (debugMode) {
      console.log("👨‍👩‍👧 Added fmesh to fullmesh");
    }
    fullmesh.add(fmeshPoints);
    if (debugMode) {
      console.log("👨‍👩‍👧 Added fmeshPoints to fullmesh");
    }
    fullmesh.rotation.x = Math.PI / 2;
    this.scene.add(fullmesh);
    if (debugMode) {
      console.log("🌍 Added fullmesh to scene");
    }
    // ============================================================
    // DEBUG REGISTRY
    // ============================================================
    if (debugMode) {
      window.debugMeshes = debugMeshes;
      window.debugScene = this.scene;
      window.debugFullMesh = fullmesh;
      window.debugFMesh = fmesh;
      window.debugFMeshPoints = fmeshPoints;
      console.log("📚 Mesh Registry Available: window.debugMeshes");
      console.log("🌍 Scene Available: window.debugScene");
      console.log("🧱 Polygon Container Available: window.debugFMesh");
      console.log("📍 Point Container Available: window.debugFMeshPoints");
      console.log("👨‍👩‍👧 Full Container Available: window.debugFullMesh");
    }
    // ============================================================
    // CROSS REFERENCE COUNTS
    // ============================================================
    if (debugMode) {
      const polygonMeshes = fmesh.children.length;
      const pointMeshes = fmeshPoints.children.length;
      const totalMeshes = polygonMeshes + pointMeshes;
      const expectedMeshes = filteredGeojson.features.length;
      console.group("✅ MESH CREATION VERIFICATION");
      console.log("📥 Filtered GeoJSON Features :", expectedMeshes);
      console.log("🏗️ Meshes Created           :", meshesCreated);
      console.log("🧱 fmesh Children           :", polygonMeshes);
      console.log("📍 fmeshPoints Children     :", pointMeshes);
      console.log("📦 Total Meshes             :", totalMeshes);
      if (
        expectedMeshes === meshesCreated &&
        meshesCreated === totalMeshes
      ) {
        console.log(
          "✅ SUCCESS - GeoJSON Feature Count Matches Mesh Count"
        );
      } else {
        console.error("🚨 MESH COUNT MISMATCH DETECTED");
        console.table({
          expectedFeatures: expectedMeshes,
          meshesCreated,
          polygonMeshes,
          pointMeshes,
          totalMeshes
        });
        const missing = expectedMeshes - totalMeshes;
        if (missing > 0) {
          console.error(`❌ Missing ${missing} mesh(es)`);
        }
        if (missing < 0) {
          console.error(`⚠️ ${Math.abs(missing)} extra mesh(es) detected`);
        }
      }
      console.groupEnd();
    }
    fmesh.position.set(-modelCenter.x, -modelCenter.y);
    this.map_repaint();
    if (!is2DViewActive) {
      this.init_animation();
    }
    fmesh.traverse((child) => {
      if (child.isMesh) {
        child.material.opacity = 0;
        child.material.transparent = true;
        child.material.needsUpdate = true;
      }
    });
    fmesh.position.set(0, 0, 0);
    setTimeout(() => {
      setUniversalDataLoaded(true);
    }, 0);
    // this.getUniqueStrings(geojson, selectedYearEditing);
    if (debugMode) {
      console.log("🏁 createShapes() complete");
      console.groupEnd();
    }
    // 
    setLOADINGPARAM_createShapes(true)
  }

  calculateHeight(metricValue, maxMetricValue, maxHeight) {
    if (maxMetricValue === 0) return 0;
    const normalizedValue = metricValue / maxMetricValue;
    return normalizedValue * maxHeight;
  }

  timestampMatchesBucket = (timestamp, selectedTimestamp) => {
    const d = new Date(timestamp);
    const selected = new Date(selectedTimestamp);

    switch (numericTimeAggregationMethod) {

      case "year":
        return (
          d.getUTCFullYear() === selected.getUTCFullYear()
        );

      case "month":
        return (
          d.getUTCFullYear() === selected.getUTCFullYear() &&
          d.getUTCMonth() === selected.getUTCMonth()
        );

      case "day":
        return (
          d.getUTCFullYear() === selected.getUTCFullYear() &&
          d.getUTCMonth() === selected.getUTCMonth() &&
          d.getUTCDate() === selected.getUTCDate()
        );

      case "hour":
        return (
          d.getUTCFullYear() === selected.getUTCFullYear() &&
          d.getUTCMonth() === selected.getUTCMonth() &&
          d.getUTCDate() === selected.getUTCDate() &&
          d.getUTCHours() === selected.getUTCHours()
        );

      default:
        return timestamp === selectedTimestamp;
    }
  }

  getAggregatedValue = (
    timeseries,
    key,
    selectedTimestamp,
    reducer = "sum"
  ) => {
    const metricData = timeseries?.[key];

    if (!metricData) {
      return 0;
    }

    const values = Object.entries(metricData)
      .filter(([timestamp]) =>
        this.timestampMatchesBucket(timestamp, selectedTimestamp)
      )
      .map(([, value]) => value);

    if (!values.length) {
      return 0;
    }

    // Strings (Land Use, Owner, etc.)
    if (typeof values[0] === "string") {
      return values[0];
    }

    switch (reducer) {
      case "average":
        return values.reduce((a, b) => a + b, 0) / values.length;

      case "max":
        return Math.max(...values);

      case "min":
        return Math.min(...values);

      case "sum":
      default:
        return values.reduce((a, b) => a + b, 0);
    }
  }

  // remove current scene functions for adding new drawing instance only - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

  removeDrawFromScene() {
    this.scene.remove(fullmesh);
  }

  // init animation - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

  init_animation = () => {
    this.map_repaint();
    setTimeout(() => {
      new TWEEN.Tween(fmesh.scale)
        .to({ z: 1 }, animate_speed)
        .easing(TWEEN.Easing.Cubic.InOut)
        .start()
        .onComplete(() => {
        });
    }, animate_speed);
    // 
    setLOADINGPARAM_initAnimation(true)
  }

  // polygon selection functions - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

  raycast(point, selectedYearEditing) {
    if (isCtrlDown) {
      return;
    }
    let mouse = new THREE.Vector2();
    mouse.x = (point.x / this.map.transform.width) * 2 - 1;
    mouse.y = 1 - (point.y / this.map.transform.height) * 2;
    const camInverseProjection = new THREE.Matrix4().getInverse(this.camera.projectionMatrix);
    const cameraPosition = new THREE.Vector3().applyMatrix4(camInverseProjection);
    const mousePosition = new THREE.Vector3(mouse.x, mouse.y, 1).applyMatrix4(camInverseProjection);
    const viewDirection = mousePosition.clone().sub(cameraPosition).normalize();
    this.raycaster.set(cameraPosition, viewDirection);
    let intersects = this.raycaster.intersectObjects(this.scene.children, true);
    if (intersects.length > 0) {
      setActiveTab("GROUP");
      this.search_by_id(intersects[0].object.name, selectedYearEditing);
    }
  }

  getFeatureAtPoint(point) {
    if (!this.map?.transform || !this.camera || !this.scene || !point) return null;

    const mouse = new THREE.Vector2();
    mouse.x = (point.x / this.map.transform.width) * 2 - 1;
    mouse.y = 1 - (point.y / this.map.transform.height) * 2;
    const camInverseProjection = new THREE.Matrix4().getInverse(this.camera.projectionMatrix);
    const cameraPosition = new THREE.Vector3().applyMatrix4(camInverseProjection);
    const mousePosition = new THREE.Vector3(mouse.x, mouse.y, 1).applyMatrix4(camInverseProjection);
    const viewDirection = mousePosition.clone().sub(cameraPosition).normalize();
    this.raycaster.set(cameraPosition, viewDirection);

    const intersects = this.raycaster.intersectObjects(this.scene.children, true);
    for (const intersection of intersects) {
      let object = intersection.object;
      while (object && !this.featureById.has(String(object.name))) {
        object = object.parent;
      }
      if (object) return this.featureById.get(String(object.name)) || null;
    }
    return null;
  }

  // polygon info functions - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

  search_by_id = (skylark_id, selectedYear) => {
    for (const feature of longstandingGeoJSONRef.current.features) {
      if (feature.skylark_id === skylark_id) {
        console.log(feature)
        setFoundFeature(feature);
        // break;
      }
    }
    this.clickedInfoPopup();
  };

  // polygon info functions - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

  multiLayerSelectedExternalSet = (set) => {
    this.multiLayerSelected = set;
  }

  greoupingSelectedExternalSet = (set) => {
    this.groupingSelected = set;
    dynamicMultuGroupSelectedArray = [];
  }

  individuallySelectedParcel = (set) => {
    this.individuallySelectedParcelBool = set;
  }

  alterLeftSubDrawerOpen = (set) => {
    this.polygonLayerLeftSubDrawerOpen = set;
    console.log(set);
  };

  alterScenarioFeatureSelectionMode = (set) => {
    this.scenarioFeatureSelectionMode = set;
  };

  alterScenarioModelledFeatureIds = (ids) => {
    this.scenarioModelledFeatureIds = ids;
  };

  alterpolygonSingleFeatureEditMode = (set) => {
    this.polygonSingleFeatureEditMode = set;
  };

  clickedInfoPopup = (event) => {
    event?.stopPropagation?.();
    if (this.infoPopupClickLocked) return;
    this.infoPopupClickLocked = true;
    requestAnimationFrame(() => {
      this.infoPopupClickLocked = false;
    });
    setIsRighdivrawerVisible(true);
    setIsRealmLeftClickedInfoVisible(true);
    setIsVisible(true);
    this.multiLayerSelected = false;
    this.groupingSelected = true;
    this.individuallySelectedParcelBool = false;
    const id = foundFeature.skylark_id;
    if (!this.scenarioFeatureSelectionMode) {
      setMultuGroupSelectedArray((prev) => {
        let updated;
        if (this.polygonSingleFeatureEditMode) {
          if (prev.includes(id)) {
            updated = [];
          } else {
            updated = [id];
          }
        } else {
          updated = prev.includes(id)
            ? prev.filter((item) => item !== id)
            : [...prev, id];
        }
        dynamicMultuGroupSelectedArray = updated;
        this.multuGroupSelectedArray = updated;
        return updated;
      });
    } else {
      if (this.scenarioModelledFeatureIds?.includes(id)) return;
      setSMSelectedArray((prev) => {
        const updated = prev.includes(id)
          ? prev.filter((item) => item !== id)
          : [...prev, id];
        return updated;
      });
    }
  };

  removedSkylarkIdFromsetMultuGroupSelectedArray(removedSkylarkId) {
    dynamicMultuGroupSelectedArray = dynamicMultuGroupSelectedArray.filter(id => id !== removedSkylarkId);
    setMultuGroupSelectedArray([...dynamicMultuGroupSelectedArray]);
    this.removeFeatureOpacities(fmesh, dynamicMultuGroupSelectedArray);
  }

  removedSkylarkIdFromsetMultuGroupSelectedArrayPoints(removedSkylarkId) {
    dynamicMultuGroupSelectedArray = dynamicMultuGroupSelectedArray.filter(id => id !== removedSkylarkId);
    setMultuGroupSelectedArray([...dynamicMultuGroupSelectedArray]);
  }

  // Assuming foundFeature is the feature found and want to highlight - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

  adjustFeatureOpacities(fmesh, multuGroupSelectedArray) {
    fmesh.traverse((child) => {
      if (child.isMesh) {
        if (multuGroupSelectedArray.includes(child.name)) {
          child.material.opacity = 1;
          child.material.needsUpdate = true;
        } else {
          child.material.opacity = .3;
          child.material.transparent = true;
          child.material.needsUpdate = true;
        }
      }
    });
    this.map_repaint();
  }

  adjustFeatureOpacitiesPoints(fmeshPoints, multuGroupSelectedArray) {
    fmeshPoints.traverse((child) => {
      if (child.isMesh) {
        if (multuGroupSelectedArray.includes(child.name)) {
          child.material.opacity = 1;
          child.material.needsUpdate = true;
        } else {
          child.material.opacity = .3;
          child.material.transparent = true;
          child.material.needsUpdate = true;
        }
      }
    });
    this.map_repaint();
  }

  // Updated to accept an array of skylark_ids - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

  removeFeatureOpacities(fmesh, skylarkIdsArray) {
    fmesh.traverse((child) => {
      if (child.isMesh) {
        if (skylarkIdsArray.includes(child.name)) {
          child.material.opacity = 1;
          child.material.needsUpdate = true;
        } else {
          child.material.opacity = .3;
          child.material.transparent = true;
          child.material.needsUpdate = true;
        }
      }
    });
    this.map_repaint();
  }

  // Utility function to repaint the map - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

  resetfeatureOpacities(fmesh) {
    fmesh.traverse((child) => {
      if (child.isMesh) {
        child.material.opacity = 1;
        child.material.transparent = true;
        child.material.needsUpdate = true;
      }
    });
    this.map_repaint();
  }

  resetFeatureOpacitiesPointsOnly(fmeshPoints) {
    fmeshPoints.traverse((child) => {
      if (child.isMesh) {
        child.material.opacity = 1;
        child.material.transparent = true;
        child.material.needsUpdate = true;
      }
    });
    this.map_repaint();
  }

  // NEW polygon update function - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
  // NEW polygon update function - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
  // NEW polygon update function - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
  // NEW polygon update function - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

  // get unique list of all strings in the geojson in selected year
  // first determine if the key + selected year is a string or number

  generateCalculationMatrix = (geojson, selectedYearEditing, keysWithStrings) => {
    let result = {};
    for (const key of keysWithStrings) {
      result[key] = {
        uniqueValues: new Set(),
        firstFeatures: [],
        numericalValues: []
      };
      for (const feature of geojson.features) {
        if (!feature.feature_data_simple_timeseries) {
          continue;
        }
        if (!(key in feature.feature_data_simple_timeseries)) {
          continue;
        }
        if (!(selectedYearEditing in feature.feature_data_simple_timeseries[key])) {
          continue;
        }
        const value = feature.feature_data_simple_timeseries[key][selectedYearEditing];
        if (typeof value === 'string' && value !== '' && value !== 'undefined' && value !== 'null') {
          result[key].uniqueValues.add(value);
          if (!result[key].firstFeatures.some(f => f.value === value)) {
            let area = null;
            if (feature.geometry) {
              area = turf.area(feature.geometry);
            }
            result[key].firstFeatures.push({ value, feature, area });
            let numericalValuesForFeature = [];
            for (const numericalKey in feature.feature_data_simple_timeseries) {
              if (
                feature.feature_data_simple_timeseries[numericalKey] &&
                selectedYearEditing in feature.feature_data_simple_timeseries[numericalKey]
              ) {
                const numValue = feature.feature_data_simple_timeseries[numericalKey][selectedYearEditing];
                if (typeof numValue === 'number') {
                  numericalValuesForFeature.push({ key: numericalKey, value: numValue });
                }
              }
            }
            result[key].numericalValues.push({
              value,
              numericalValues: numericalValuesForFeature
            });
          }
        } else {
        }
      }
    }
    for (const key in result) {
      result[key].numericalValues = result[key].numericalValues.map(item => {
        return {
          value: item.value,
          results: item.numericalValues.map(numerical => {
            let dividedValue = null;
            const firstFeature = result[key].firstFeatures.find(f => f.value === item.value);
            if (firstFeature && firstFeature.area !== null) {
              dividedValue = numerical.value / firstFeature.area
            }
            return {
              key: numerical.key,
              area: firstFeature.area,
              originalValue: numerical.value,
              dividedValue
            };
          })
        };
      });
    }
    for (const key in result) {
      result[key].uniqueValues = Array.from(result[key].uniqueValues);
    }
    this.globalValuesMatrix = result;
  };

  clearMeshGroup(group) {
    while (group.children.length > 0) {
      const child = group.children.pop();
      child.traverse((object) => {
        object.geometry?.dispose();
        if (Array.isArray(object.material)) object.material.forEach((material) => material.dispose());
        else object.material?.dispose();
      });
    }
  }

  getUniqueStrings = (geojson, selectedYearEditing) => {
    let keysWithStrings = new Set();
    for (const feature of geojson.features) {
      for (const key in feature.feature_data_simple_timeseries) {
        const value = feature.feature_data_simple_timeseries[key][selectedYearEditing];
        if (typeof value === 'string') {
          keysWithStrings.add(key);
        }
      }
    }
    this.generateCalculationMatrix(geojson, selectedYearEditing, Array.from(keysWithStrings));
  };

  handleRecalculateValues = (updatedFeaturesSkylarkID) => {
    console.log(updatedFeaturesSkylarkID)
    longstandingGeoJSONRef.current.features.forEach((feature) => {
      if (!updatedFeaturesSkylarkID.includes(feature.skylark_id)) return;
      let updatedFeature = { ...feature };
      const selectedKey = this.currentlandKeySelectedKey;
      const selectedMetricValue = updatedFeature.feature_data_simple_timeseries[selectedMetric]?.[selectedYearEditing];
      const selectedKeyValue = updatedFeature.feature_data_simple_timeseries[selectedKey]?.[selectedYearEditing];
      const featureArea = updatedFeature.feature_data_simple_timeseries.Shape_Area[selectedYearEditing];
      if (this.globalValuesMatrix.hasOwnProperty(selectedKey)) {
        Object.keys(updatedFeature.feature_data_simple_timeseries).forEach((key) => {
          if (typeof updatedFeature.feature_data_simple_timeseries[key][selectedYearEditing] === 'number') {
            const numericalValueEntry = this.globalValuesMatrix[selectedKey].numericalValues.find(
              item => item.value === selectedKeyValue
            );
            if (numericalValueEntry && Array.isArray(numericalValueEntry.results)) {
              const resultEntry = numericalValueEntry.results.find(result => result.key === key);
              if (resultEntry && typeof resultEntry.dividedValue === 'number') {
                const updatedValue = featureArea * resultEntry.dividedValue;
                const years = Object.keys(updatedFeature.feature_data_simple_timeseries[key]);
                const startYearIndex = years.indexOf(selectedYearEditing);
                if (startYearIndex !== -1) {
                  for (let i = startYearIndex; i < years.length; i++) {
                    const year = years[i];
                    updatedFeature.feature_data_simple_timeseries[key][year] = updatedValue;
                  }
                }
              } else {
                console.warn(`No valid 'dividedValue' found for key: ${key}`);
              }
            } else {
              console.warn(`No matching numerical value entry found for key: ${selectedKey}`);
            }
          }
        });
      } else {
        console.warn(`selectedKey '${selectedKey}' does not exist in globalValuesMatrix`);
      }
      const updatedGeoJSON = { ...longstandingGeoJSONRef.current };
      const featureIndex = updatedGeoJSON.features.findIndex(f => f.skylark_id === updatedFeature.skylark_id);
      updatedGeoJSON.features[featureIndex] = updatedFeature;
      longstandingGeoJSONRef.current = updatedGeoJSON;
    });
  };

  // END OF NEW polygon update function - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
  // END OF NEW polygon update function - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
  // END OF NEW polygon update function - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
  // END OF NEW polygon update function - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

  // polygon update function - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

  handleCloseClickedInfo = (globalLandtype, selectedYearEditing) => {
    const interfeatures = longstandingGeoJSONRef.current.features;
    const currentSelectedYear = selectedYearEditing;
    newFeatureDepth = this.calculateAllMetric(foundFeature, globalLandtype);
    let newFeatureDepthSelectedMetric = newFeatureDepth[selectedMetric];
    setAcknowledgeNewFaetureNewDepth(newFeatureDepth);
    this.animate_change(foundFeature, newFeatureDepthSelectedMetric);
    this.updateJson(interfeatures, globalLandtype, currentSelectedYear, newFeatureDepth);
    setClickedInfo(null);
    this.map_repaint();
    setdropdownhighlightedIndex(null);
    return null;
  };

  // polygon info close functions - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

  handleCloseClickedInfoButton = () => {
    this.resetfeatureOpacities(fmesh);
    setIsVisible(false);
    setClickedInfo(null);
    this.map_repaint();
    setdropdownhighlightedIndex(null);
    return null;
  };

  // polygon info close cancel functions - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

  // handleCloseClickedInfoCancel = () => {
  //   return null;
  // };

  // polygon animation function - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

  animate_change = (feature, growth) => {
    this.map_repaint();
    fmesh.traverse((child) => {
      if (child.name === feature.skylark_id) {
        new TWEEN.Tween(child.scale)
          .to({ z: - growth }, animate_speed)
          .easing(TWEEN.Easing.Cubic.InOut)
          .onUpdate(() => {
          })
          .start();
      }
    });
  };

  // camera fly to function - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

  cameraFlyToLatLong = (latitude, longitude) => {
    this.map.flyTo({
      center: [longitude, latitude],
      zoom: 15,
      essential: true,
      speed: 3
    });
  };

  // camera fly to north - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

  cameraFlyToNorth = () => {
    this.map.flyTo({
      bearing: 0,
      essential: true,
      speed: 3
    });
  };

  // swap map base function - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

  swapMapBase = (style) => {
    if (style === 'Satellite') {
      this.map.setLayoutProperty('mapbox-satellite', 'visibility', 'visible');
    }
    if (style === 'Map') {
      this.map.setLayoutProperty('mapbox-satellite', 'visibility', 'none');
    }
  }

  // 2d view - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

  setCameraTo2DView() {
    this.map.flyTo({
      essential: true,
      speed: .2,
      pitch: 0
    });
  }

  // 3d view - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

  setCameraTo3DView(selectedYearEditing) {
    this.map.flyTo({
      essential: true,
      speed: .2,
      pitch: 60
    });
  }

  // set landtype function - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

  setLandtype(landtypes, selectedKey) {
    fmesh.children.forEach((child) => {
      if (landtypes.includes("Hide all")) {
        child.visible = false;
      } else {
        const skylarkId = child.name;
        const feature = longstandingGeoJSONRef.current.features.find(
          (f) => f.skylark_id === skylarkId
        );
        if (feature && feature.feature_data_simple_timeseries[selectedKey] && feature.feature_data_simple_timeseries[selectedKey][selectedYearEditing] && landtypes.some((landtype) =>
          feature.feature_data_simple_timeseries[selectedKey][selectedYearEditing].includes(landtype)
        )) {
          child.visible = true;
        } else {
          child.visible = false;
        }
      }
    });
    this.map_repaint();
    if (landtypes.length === 0 || landtypes.includes("Show all")) {
      fmesh.children.forEach((child) => {
        const skylarkId = child.name;
        const feature = longstandingGeoJSONRef.current.features.find(
          (f) => f.skylark_id === skylarkId
        );
        if (feature) {
          child.visible = true;
        }
      });
      this.map_repaint();
    }
  }

  //

  setTransparency(transparency) {
    fmesh.traverse((child) => {
      if (child.isMesh) {
        child.material.transparent = true;
        child.material.opacity = transparency;
      }
    });
    this.map_repaint();
  }

  // set landtype function - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

  setPieLandtype(landtypes, selectedKey) {
    fmesh.children.forEach((child) => {
      if (landtypes.includes("Hide all")) {
        child.visible = false;
      } else {
        const skylarkId = child.name;
        const feature = longstandingGeoJSONRef.current.features.find(
          (f) => f.skylark_id === skylarkId
        );
        if (feature && feature.feature_data_simple_timeseries[selectedKey] && feature.feature_data_simple_timeseries[selectedKey][selectedYearEditing] && landtypes.some((landtype) =>
          feature.feature_data_simple_timeseries[selectedKey][selectedYearEditing].includes(landtype)
        )) {
          child.visible = true;
        } else {
          child.visible = false;
        }
      }
    });
    this.map_repaint();
    if (landtypes.length === 0 || landtypes.includes("Show all")) {
      fmesh.children.forEach((child) => {
        const skylarkId = child.name;
        const feature = longstandingGeoJSONRef.current.features.find(
          (f) => f.skylark_id === skylarkId
        );
        if (feature) {
          child.visible = true;
        }
      });
      this.map_repaint();
    }
  }

  // 

  // map repaint function - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

  map_repaint() {
    if (this.repaintFrame) {
      return;
    }
    const start = performance.now();
    const duration = animate_speed * 2;
    const repaint = now => {
      this.map.triggerRepaint();
      if (now - start < duration) {
        this.repaintFrame = requestAnimationFrame(repaint);
      } else {
        this.repaintFrame = null;
      }
    };
    this.repaintFrame = requestAnimationFrame(repaint);
  }

  // render function - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

  render(gl, matrix) {
    const timestamp = new Date().toISOString();
    if (debugMode && !this._renderDebugLogged) {
      console.group(timestamp + " " + "🎬 FIRST RENDER DETAILS");
      console.log("🎮 WebGL Context", gl);
      console.log("📐 Incoming Matrix", matrix);
      console.log("🌍 Model Transform", this.modelTransform);
      console.log("📷 Camera", this.camera);
      console.log("🎨 Renderer", this.renderer);
      console.log("🎭 Scene", this.scene);
      console.log("🧱 fmesh", fmesh);
      console.log("📍 fmeshPoints", fmeshPoints);
      console.log("👨‍👩‍👧 fullmesh", fullmesh);
      console.log("📦 Scene Children", this.scene.children.length);
      console.groupEnd();
      // Make everything easily inspectable from DevTools
      window.renderDebug = {
        renderer: this.renderer,
        scene: this.scene,
        camera: this.camera,
        modelTransform: this.modelTransform,
        fmesh,
        fmeshPoints,
        fullmesh
      };
      this._renderDebugLogged = true;
    }
    TWEEN.update();
    const rotationX = new THREE.Matrix4().makeRotationAxis(
      new THREE.Vector3(1, 0, 0),
      this.modelTransform.rotateX
    );
    const rotationY = new THREE.Matrix4().makeRotationAxis(
      new THREE.Vector3(0, 1, 0),
      this.modelTransform.rotateY
    );
    const rotationZ = new THREE.Matrix4().makeRotationAxis(
      new THREE.Vector3(0, 0, 1),
      this.modelTransform.rotateZ
    );
    const m = new THREE.Matrix4().fromArray(matrix);
    const l = new THREE.Matrix4()
      .makeTranslation(
        this.modelTransform.translateX,
        this.modelTransform.translateY,
        this.modelTransform.translateZ
      )
      .scale(
        new THREE.Vector3(
          this.modelTransform.scale,
          -this.modelTransform.scale,
          this.modelTransform.scale
        )
      )
      .multiply(rotationX)
      .multiply(rotationY)
      .multiply(rotationZ);
    if (debugMode && !this._projectionDebugLogged) {
      console.group(timestamp + " " + "📷 PROJECTION MATRIX BUILT");
      console.log("🔄 Rotation X", rotationX);
      console.log("🔄 Rotation Y", rotationY);
      console.log("🔄 Rotation Z", rotationZ);
      console.log("📐 Map Matrix (m)", m);
      console.log("🧮 Local Transform (l)", l);
      console.groupEnd();
      this._projectionDebugLogged = true;
    }
    this.camera.projectionMatrix = m.multiply(l);
    this.renderer.state.reset();
    try {
      this.renderer.render(this.scene, this.camera);
    }
    catch (error) {
      if (debugMode) {
        console.group("🚨 THREE.JS RENDER FAILURE");
        console.error("❌ Render error:", error);
        console.log("🎬 Scene:", this.scene);
        console.log("📷 Camera:", this.camera);
        console.log("🎨 Renderer:", this.renderer);
        console.log("📊 Renderer Info:", this.renderer.info);
        console.groupEnd();
        window.renderErrorDebug = {
          error,
          scene: this.scene,
          camera: this.camera,
          renderer: this.renderer,
          rendererInfo: this.renderer.info,
          fmesh,
          fmeshPoints,
          fullmesh
        };
      }
    }
    if (debugMode && !this._renderCompleteLogged) {
      console.log("✅ First frame rendered successfully.");
      this._renderCompleteLogged = true;
    }
    if (debugMode) {
      window.renderStats = {
        frame: (window.renderStats?.frame || 0) + 1,
        sceneChildren: this.scene.children.length,
        meshes: fmesh.children.length,
        pointMeshes: fmeshPoints.children.length,
        rendererInfo: this.renderer.info
      };
    }
  }

}

export default harrierPolygonLayer;
